export const depositRequiredResponse = {
  details: {
    finalStatus: 'Order Requires Deposit',
    providerName: 'frontier',
    serviceAddress: '123 Main Street, Dallas TX 75001',
    switchDate: '2020-01-01',
    providerData: '{}',
  },
  partner: 'wattbuy',
  partnerOrderId: 'WB-1234',
  plan: {
    details: {
      finalStatus: 'Order Requires Deposit',
      providerName: 'frontier',
      serviceAddress: '123 Main Street, Dallas TX 75001',
      switchDate: '2020-01-01',
      providerData: '{}',
    },
    partner: 'wattbuy',
    partnerOrderId: 'WB-1234',
    plan: {},
    status: 'deposit_required',
    provider: 'frontier',
    providerOrderId: 'F123456',
    utilityKind: 'electric',
  },
  status: 'deposit_required',
  provider: 'frontier',
  providerOrderId: 'F123456',
  utilityKind: 'electric',
};
